import {
  GiMusicalKeyboard,
  GiPipeOrgan,
  GiDrumKit,
  GiGrandPiano,
  GiXylophone,
  GiGuitarHead,
  GiGuitarBassHead,
} from "react-icons/gi";

let okawe =
  //
  "muted";
// "clean";
// "jazz";
// "distorted";

// 1guitar
let guitto = {
  //
  nylon: 244,
  steel: 260,
  jazz: 274,
  clean: 286,
  muted: 299,
  overdrive: 315,
  distorted: 333,
  harmonics: 345,
}[okawe];

export const instConst = {
  Piano: { midCode: 3, icon: <GiGrandPiano /> },
  "Electric Piano": { midCode: 50, icon: <GiMusicalKeyboard /> },
  Xylophone: { midCode: 3, icon: <GiXylophone /> },
  Organ: { midCode: 3, icon: <GiPipeOrgan /> },
  Drums: { midCode: 3, icon: <GiDrumKit /> },
  Guitar: { midCode: guitto, icon: <GiGuitarHead /> },
  Bass: { midCode: 3, icon: <GiGuitarBassHead /> },
};

export const instuArray = [
  //
  "Piano",
  "Electric Piano",
];
